import React, { useEffect, useRef, useState } from 'react';
import { IconCheck, IconTransfer } from '@tabler/icons-react';

/**
 * Seletor "Transferir" setor — ícone bch-icon-btn + menu estilo thread-more.
 * Lista todos os times do tenant (não só is_member).
 */
export function BoardChatTeamTransferMenu({
  currentTeamId,
  teams = [],
  loading = false,
  transferring = false,
  disabled = false,
  onTransfer,
  tipProps,
  hideTip,
}) {
  const wrapRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (wrapRef.current?.contains(e.target)) return;
      setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDoc, true);
    window.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc, true);
      window.removeEventListener('keydown', onKey);
    };
  }, [open]);

  useEffect(() => {
    if (disabled) setOpen(false);
  }, [disabled]);

  const handleToggle = () => {
    if (disabled || transferring || loading) return;
    hideTip?.();
    setOpen((v) => !v);
  };

  const handlePick = (teamId) => {
    if (transferring || disabled) return;
    if (Number(teamId) === Number(currentTeamId)) {
      setOpen(false);
      return;
    }
    setOpen(false);
    onTransfer?.(teamId);
  };

  return (
    <div className="bch-transfer-wrap" ref={wrapRef}>
      <button
        type="button"
        className={`bch-icon-btn${open ? ' is-open' : ''}`}
        aria-label="Transferir para outro setor"
        aria-expanded={open}
        aria-haspopup="menu"
        disabled={disabled || transferring || loading}
        {...(open || disabled || !tipProps ? {} : tipProps('Transferir para outro setor'))}
        onClick={handleToggle}
      >
        <IconTransfer size={17} stroke={1.7} aria-hidden />
      </button>
      {open ? (
        <div className="bch-thread-more-menu bch-transfer-menu" role="menu" aria-label="Transferir para setor">
          {loading ? (
            <div className="bch-thread-more-empty">Carregando times…</div>
          ) : teams.length === 0 ? (
            <div className="bch-thread-more-empty">Nenhum time disponível</div>
          ) : (
            teams.map((t) => {
              const active = Number(t.id) === Number(currentTeamId);
              return (
                <button
                  key={t.id}
                  type="button"
                  role="menuitem"
                  className={`bch-thread-more-item${active ? ' is-current' : ''}`}
                  disabled={transferring || active}
                  onClick={() => handlePick(t.id)}
                >
                  <span className="bch-transfer-item-label">{t.name}</span>
                  {active ? <IconCheck size={14} stroke={1.8} aria-hidden /> : null}
                </button>
              );
            })
          )}
        </div>
      ) : null}
    </div>
  );
}
